import { ResolveFn, Router } from '@angular/router';
import { CollaborationService } from '../dashboard/services/collaboration.service';
import { inject } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';

export const collaborationResolver: ResolveFn<any> = (route, state) => {
  const service = inject(CollaborationService);
  const router = inject(Router);
  
  const slug = route.paramMap.get('slug');
  return service.getPublicCollaborationBySlug(slug!).pipe(
    catchError((error) => {
      console.error('Resolver error:', error);

      // Redirect to 404 page
      router.navigate(['/not-found']);

      return EMPTY;
    })
  );
};
